import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Sparkles } from 'lucide-react';
/**
 * Renders a single release note's user-facing highlights. Shared by the
 * "What's new" popup and the release-history page.
 */
export function ReleaseNoteContent({ note }) {
    return (_jsx("div", { className: "space-y-3", children: note.highlights.map((h, i) => (
        // react-doctor-disable-next-line react-doctor/no-array-index-as-key -- read-only render of a fixed note's highlights; never reorders/filters and items carry no state
        _jsxs("div", { className: "flex gap-3", children: [_jsx(Sparkles, { className: "text-primary mt-0.5 h-4 w-4 shrink-0", "aria-hidden": true }), _jsxs("div", { className: "min-w-0", children: [_jsx("p", { className: "text-foreground text-sm font-medium", children: h.title }), _jsx("p", { className: "text-muted-foreground mt-0.5 text-sm leading-relaxed", children: h.body })] })] }, i))) }));
}
